'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _lodashUniq = require('lodash.uniq');

var _lodashUniq2 = _interopRequireDefault(_lodashUniq);

var _hierarchyClassIdBySubclassId = require('./hierarchy/class-id-by-subclass-id');

var _hierarchyClassIdBySubclassId2 = _interopRequireDefault(_hierarchyClassIdBySubclassId);

exports['default'] = function (query) {
  var expansions = {};

  if (query.subclassification && !query.classification) {
    var classIds = query.subclassification.split(',').map(_hierarchyClassIdBySubclassId2['default']).filter(function (x) {
      return x;
    });

    if (classIds.length > 0) {
      expansions.classification = (0, _lodashUniq2['default'])(classIds).join(',');
    }
  }

  return _extends({}, query, expansions);
};

module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./~/@seek/seek-jobs-seo/build/expand-query.js
 ** module id = 542
 ** module chunks = 0
 **/